import view from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			date:       '=',
			dateFormat: '@',
			config:     '=?config',
			onSetTime:  '=',
		},
		controller: /* @ngInject */ ($scope) => {
			$scope.isOpen = false;

			if (!$scope.dateFormat) {
				$scope.dateFormat = 'DD/MM/YYYY HH:mm:ss Z';
			}

			$scope.onSetTimeCallback = (newTime, oldTime) => {
				$scope.isOpen = false;

				if ($scope.onSetTime) {
					$scope.onSetTime(newTime, oldTime);
				}
			};

			$scope.config = {
				...$scope.config,
				modelType: 'moment',
			};
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/datetimePicker/index.js